import { render, staticRenderFns } from "./IconBjjlink.vue?vue&type=template&id=6ab6e95d"
import script from "./IconBjjlink.vue?vue&type=script&lang=js"
export * from "./IconBjjlink.vue?vue&type=script&lang=js"
import style0 from "./IconBjjlink.vue?vue&type=style&index=0&id=6ab6e95d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports